import { generateManifest2ColumnLandscape } from "./landscape";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { Dispatch } from "@/domain/entities/Dispatch";
import { AccountController } from "@/app/ui/controllers/AccountController";
import jsPDF from "jspdf";
import generateDispatchSttFailed from "./pdf-layout-failed";
import { generateManifest2ColumnPotrait } from "./potrait";

export const onPrintDispatchManifest = async (detailData: Dispatch) => {
  MainAppController.showLoading();
  // Get role account type
  const roleAccount =
    AccountController.accountData.account_type === "partner"
      ? AccountController.accountData.account_type_detail.type
      : AccountController.accountData.account_type || "internal";

  // Load logo and get its default export
  const logoModule = await import(
    `@/app/ui/assets/images/logo-${roleAccount}.png`
  );
  const importLogo = logoModule.default;

  const doc = new jsPDF("portrait", "mm", "a4", true);

  const successData = new Dispatch({
    ...detailData,
    stts: detailData.stts.filter(item => item.ddScanStatus === "success")
  });

  const noSuccessData = new Dispatch({
    ...detailData,
    stts: detailData.stts.filter(item => item.ddScanStatus !== "success")
  });

  // Generate manifest
  if (successData.stts.length > 0) {
    await generateManifest2ColumnPotrait(doc, successData);
  } else {
    doc.deletePage(1); // Delete first page if no success data
  }

  // Generate failed dispatch report if there are failed items and no success items
  if (noSuccessData.stts.length > 0 && !successData.stts.length) {
    await generateDispatchSttFailed({
      doc,
      sttData: noSuccessData,
      logo: importLogo
    });
  }

  doc.setProperties({ title: `DISPATCH Manifest - ${detailData.dispatchId}` });
  doc.autoPrint();
  window.open(doc.output("bloburl").toString(), "_blank");
  MainAppController.closeLoading();
};
